import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/functions';

const local = location.hostname === 'localhost';

firebase.initializeApp({
  apiKey: 'AIzaSyC6UV7k28JOAClx9zPkXnUPJz7uGImEM7s',
  authDomain: local ? 'http://localhost:9099/?ns=word-sprints' : 'word-sprints.firebaseapp.com',
  databaseURL: local ? 'http://localhost:9000/?ns=word-sprints' : 'https://word-sprints.firebaseio.com',
  projectId: 'word-sprints',
  appId: '1:839193740503:web:05d00432fe8ca5771edc92',
  measurementId: 'G-072ERQRVCK'
});

type Analytics = Pick<firebase.analytics.Analytics, 'logEvent'>;

export { firebase };
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const database = firebase.database();
export let analytics: Analytics = {
  logEvent: (...args) => console.info('LOG:', ...args)
};

if (local) {
  firestore.settings({ host: 'localhost:9001', ssl: false });
} else {
  analytics = firebase.analytics();
}

const query = new URLSearchParams(location.search);

if (query.get('token')) {
  auth.signInWithCustomToken(query.get('token'));
}
